import storage from '@/utils/storage'
import service from '@/utils/service'
import FileSaver from 'file-saver'
const state = {
    loading: true,
    query: -1,
    remember: false,
    page: {

    },
}

const mutations = {
    set_loading (state, loading) {
      state.loading = loading
    },
    set_remember (state, remember) {
      state.remember = remember
    },
    set_query (state, query) {
      state.query = query
    },
    set_page(state, page) {
      state.page = page
    },
    set_page_config(state, config) {
      state.page[config.id] = config.val
    },
    clear_page(state, page) {
      state.page = {}
    },
    set_menuHistory (state, keywords) {
      if(keywords && keywords!='') {
        let histories = storage.local.get('menu_history')
        if(!histories) {
            histories = []
        }
        let new_histories = [keywords]
        for(let i=0; i<histories.length; i++) {
          let h = histories[i]
          if(new_histories.indexOf(h)<0) {
            new_histories.push(h)
          }
          if(new_histories.length >= 5) {
            break
          }
        }
        storage.local.set('menu_history', new_histories)
      }
    },
  }


const actions = {
  init_remember(context) {
    const remember = storage.local.get('remember')
    context.commit('set_remember', remember)
  },
  set_remember(context, val) {
    if (val) {
      storage.local.set('remember', true)
    } else {
      storage.local.remove('remember')
    }
    context.commit('set_remember', val)
  },
  async init_page(context, id) {
    context.commit('clear_page')
    await service.getData(`${service.api.project.config}${id}/`).then((data)=>{
      context.dispatch('init_page_config', data)
    }).catch((data)=> {
      context.commit('set_page', Object.assign({error:true}, data))
    })
  },
  init_page_config(context, data) {
    let url = data.other?data.other.url:null
    if(url && url!='') {
        location.href = url
    }

    let page = {}
    let fields = ['id', 'parent', 'name', 'desc', 'ctrl', 'searchers', 'modules', 'marks', 'status', 'staffs', 'open', 'star']
    fields.forEach(f=>{
      page[f] = data[f]
    })
    page.autoquery = (data.other?data.other.autoquery:null)===false?false:true
    page.fuxi = data.other && data.other.fuxi==false?false:true
    page.pageSize = data.other && data.other.pagesize?data.other.pagesize:30
    page.language = data.other && data.other.language ? data.other.language : 'zh_CN';
    page.watermark = data.other && data.other.watermark===false?false:true
    page.topscroll = data.other && data.other.topscroll
    page.widescreen = data.other && data.other.widescreen
    page.downloadForbidden = data.other && data.other.downloadForbidden
    
    if(data.other && data.other.table_change) {
      page.table = {
        change: true,
        fields: eval('(' + data.other.table_fields + ')'),
        name: data.other.table_name,
        id: data.other.table_id,
      }
    }
    
    if(data.other && data.other.color_ctrl) {
        page.color = {
          colorful: data.other.color_ctrl,
          critical: data.other.critical?data.other.critical:0,
          direct: data.other.direct
        }
    }

    if(['common', 'dynamic', 'tabs', 'compare', 'balance', 'download', 'report'].indexOf(data.ctrl) < 0) {
        page.custom_ctrl = require(`@/components/game/ctrl/${data.ctrl}.vue`).default
    }
    context.commit('set_page', page)
  }
}

const getters = {
  
}
  
export default {
  state,
  mutations,
  actions,
  getters
}